import React from 'react' 
import { graphql, StaticQuery } from 'gatsby'
import styled from 'styled-components'
import Img from 'gatsby-image'

const StyledUnderline = styled.div`
  width: 50px;
  height: 4px;
  background: #2c5282;
  margin-top: 50px;
  margin-bottom: 22px;
`

const PageContactSectionNew = () => (
  <StaticQuery 
    query={query}
    render={
      data => {
        const imageDataOne = data.imageOne.childImageSharp.fluid

        return (
          <div className="bg-gray-200">
            <div className="lg:w-10/12 mx-auto py-20 sm:py-6 sm:px-4 md:py-12 md:px-8">
              <h2 className="font-display text-gray-900 text-3xl sm:text-2xl leading-snug mb-6">
                Corporate Office Information
              </h2>

              <p className='text-xl text-gray-900 ml-4'>
                <strong>Phone:</strong> <a href='tel:714-891-8804' className='underline'>(714) 891-8804</a> or <a href='tel:800-714-0200' className='underline'>(800) 714-0200</a><br/>
                <strong>After Hours Emergencies:</strong> <a href='tel:800-408-3469' className='underline'>(800) 408-3469</a><br/>
                <strong>Fax:</strong> (714) 894-5643<br/>
              </p>

              <div className="lg:flex block">
                <div className="lg:w-1/2 w-full">
                  <StyledUnderline></StyledUnderline>
                  <h3 className="font-display text-gray-900 text-2xl mb-2 font-bold">
                    Interpacific Asset Management - Orange County
                  </h3>

                  <p className="text-xl text-gray-900 mb-6">
                    5505 Garden Grove Blvd., Suite 150
                    <br />
                    Westminster, CA 92683
                  </p>
                </div>                        
              </div>

              <div>
                <Img fluid={imageDataOne} alt='Google map directions for Interpacific Asset Management' className='w-9/12 sm:w-full shadow-lg' />
              </div>
            </div>
          </div>
        )
      }
    }
  />
)

export default PageContactSectionNew

const query = graphql`
  query PageContactSectionNewQuery {
    imageOne: file(relativePath: { eq: "header/iam-map-1.png" }) {
      childImageSharp {
        fluid(maxWidth: 959) {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`